export const MESSAGE_ERROR = 'Ocurrió un error inesperado, por favor intente nuevamente.';
export const MESSAGE_INFO = 'No hay mas datos para mostrar';